export default "__VITE_ASSET__CrBTtW5n__"